module.exports = __webpack_public_path__ + "static/media/desktop_background_night.7f835dc7.png";